<template>
  <el-dialog custom-class="pharmacy-dialog" title="处方详情" :visible.sync="dialogVisible">
    <div class="pharmacy-detail">
      <div class="pharmacy-detail__header">
        <el-row class="mb10" type="flex" justify="space-between">
          <span class="title">{{detailInfo.hosName}}处方</span>
        </el-row>
        <div>处方编号：{{detailInfo.orderNo}}</div>
        <div>开方时间：{{detailInfo.createTime | formatTime}}</div>
      </div>
      <ul class="pharmacy-detail__pat-info">
        <li>
          <span>患者姓名：{{detailInfo.compatName}}</span>
          <span class="ml20">性别：{{detailInfo.compatGender | formatterCompatGender}}</span>
          <span class="ml20">年龄：{{detailInfo.compatAge}}岁</span>
        </li>
        <li>
          <span>初步诊断：{{detailInfo.diagnosis}}</span>
        </li>
      </ul>
      <section class="pharmacy-detail__content drug-list">
        <div class="flex pt10 jcb">
          <div  class="flex"><img src="../../../assets/icon/prescription/medicine.png" alt=""><span class="fs16 bold ml10">西药药品</span></div>
          <span>总价：{{detailInfo.totalPrice/100}}元</span>
        </div>
        <ul class="drug-list__content">
          <li class="drug-list__content-item" v-for="item in detailInfo.drugList" :key="item.id">
            <div class="flex1">
              <el-row type="flex" justify="space-between">
                <div>
                  <span>{{item.drugName}}</span>
                  <span class="ml20">{{item.drugSpecification}}</span>
                </div>
                <div class="price">¥{{item.drugUnitPrice/100}}</div>
              </el-row>
              <el-row type="flex" justify="space-between">
                <span>用法用量：{{item.admission}}，{{item.frequencyName}}，每次{{item.dosage}}{{item.dosageUnit}}</span>
                <span class="count">x{{item.amount}}</span>
              </el-row>
            </div>
          </li>
        </ul>
      </section>
      <!--<div class="pharmacy-detail__footer">-->
        <!--<div class="button-box">-->
          <!--<div class="button-box__title">-->
            <!--<div class="desc">开方医生：</div>-->
            <!--<div class="doctor-name">{{detailInfo.docName}}</div>-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="button-box">-->
          <!--<div class="button-box__title">-->
            <!--<div class="desc">审核医生：</div>-->
            <!--<div class="doctor-name">{{detailInfo.auditorName}}</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <div class="mt20 flex jca">
        <div class="flex1 flex column jcc">
          <span class="fs14 color_333">开方医生:</span>
          <img :src="'data:image/png;base64,'+detailInfo.openStamp" alt="" class="width50">
        </div>
        <div class="flex1 flex column">
          <span class="fs14 color_333">审核医生:</span>
          <img :src="'data:image/png;base64,'+detailInfo.auditStamp" alt="" class="width50">
        </div>
      </div>
    </div>
    <div class="harvest-address flex1">
      <div class="harvest-address__header">
        <el-row class="mb10" type="flex" justify="end">
          <span class="status">{{formatStatus(detailInfo.takeMode, detailInfo.status)}}</span>
        </el-row>
        <div>出药单位：{{detailInfo.takeHosInfo.hosName}}</div>
        <div>取药方式：{{detailInfo.takeMode | formatTakeMode}}</div>
      </div>
      <div class="ab">
        <div v-if="waitInvite" class="confirm-btn" @click="sureTakeOff">确认患者已取药</div>
        <div v-if="detailInfo.recipePdfUrl"  class="confirm-btn mt20" @click="printBiz(detailInfo.recipePdfUrl)">打印处方单</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import axiosUtil from "../../utils/AxiosUtils";
import { timeFormat, sex } from "ty-vue-filters";
import {sexFilter} from "../../lib/filters"
import { formatStatus } from "../../utils/pharmacy";
import {tokenCache} from "../../../cache/tokenCache";

export default {
  props: {
    visible: Boolean,
    detailInfo: Object
  },
  data() {
    return {
      reason: ""
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    waitInvite() {
      return this.detailInfo.status === 'PAY' && this.detailInfo.takeMode === 'SELF'
    }
  },
  filters: {
    formatTime(time) {
      return timeFormat(time, "%Y/%m/%d %H:%M");
    },
    formatterCompatGender(code) {
      return sexFilter(code, 1);
    },
    formatTakeMode(code) {
      const takeModes = {
        SELF: "患者自取",
        LOGISTICS: "送药到家"
      };
      return takeModes[code];
    }
  },
  methods: {
    formatStatus,
    handleAudit(opts) {
      axiosUtil(
        {
          service: "smarthos.recipe.order.audit",
          orderId: this.detailInfo.id,
          token: localStorage.getItem("token"),
          ...opts
        },
        (code, msg) => {
          if (code === "0") {
            this.$emit("update:visible", false);
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    async sureTakeOff(){
      const {code} = await this.$http('smarthos.recipe.order.dispensing',{
        orderId:this.detailInfo.id,
        token: tokenCache.get()
      })
      if(code=='0'){this.dialogVisible = false}
    },
    async printBiz(url){
        window.open(url);//http://test-img-smarthos.hztywl.cn/RECIPE_201909_mQz5FX3_1gnVgd.pdf
    }

  }
};
</script>

<style lang="scss">
.pharmacy-dialog {
  .el-dialog {
    &__header {
      border-bottom: 1px solid #e8e8e8;
    }
    &__body {
      padding-top: 12px;
      display: flex;
    }
  }
  .pharmacy-detail {
    width: 400px;
    border-right: 1px solid #e8e8e8;
    padding-right: 45px;
    &__header {
      border-bottom: 1px dashed #e5e5e5;
      padding-bottom: 10px;
      .title {
        font-size: 18px;
        color: #333333;
      }
      .status {
        color: #3692f9;
      }
    }
    &__pat-info {
      padding: 12px 0;
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      border-bottom: 1px dashed #e5e5e5;
    }
    &__footer {
      display: flex;
      justify-content: space-around;
      height: 240px;
    }
    .button-box {
      padding-top: 20px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      &__title {
        width: 5em;
        margin: 0 auto;
        .desc {
          color: #333;
        }
      }
    }
    .doctor-name {
      font-size: 22px;
      color: #333333;
    }
    .drug-list {
      &__header {
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
        padding-top: 10px;
      }
      &__content-item {
        display: flex;
        padding: 5px 0;
        border-bottom: 1px dashed #e5e5e5;
        .price {
          color: #ffc149;
        }
        .count {
          color: #0893ff;
        }
        .arrow-right-area {
          width: 21px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
      }
    }
  }
  .harvest-address {
    padding-left: 20px;
    position: relative;
    &__header {
      border-bottom: 1px dashed #e5e5e5;
      padding-bottom: 10px;
    }
    .confirm-btn {
      width: 182px;
      padding: 11px 0;
      font-size: 16px;
      color: #3692f9;
      text-align: center;
      line-height: 14px;
      background: #fafafa;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      cursor: pointer;
    }
    .ab{
      position: absolute;
      left: 50%;
      margin-left: -91px;
      bottom: 90px;
    }
    .status {
      color: #3692f9;
    }
  }
}
</style>
